(function () {
  function init() {
    document.querySelectorAll('.spclst-pdp-v2 [data-spclst-size-guide-modal]').forEach(function (modal) {
      if (modal.dataset.spclstFocusTrap === 'true') return;
      modal.dataset.spclstFocusTrap = 'true';
      var dialog = modal.querySelector('[role="dialog"]');
      if (!dialog) return;
      function isOpen() { return modal.classList.contains('is-open'); }
      function focusables() {
        return Array.prototype.filter.call(dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]'), function (element) {
          return !element.disabled && element.tabIndex >= 0 && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
        });
      }
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || !isOpen()) return;
        var items = focusables();
        var first = items[0];
        var last = items[items.length - 1];
        var active = document.activeElement;
        if (!items.length) {
          event.preventDefault();
          dialog.focus({ preventScroll: true });
        } else if (!dialog.contains(active) || active === dialog || (event.shiftKey ? active === first : active === last)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus({ preventScroll: true });
        }
      }, true);
      document.addEventListener('focusin', function (event) {
        if (isOpen() && !dialog.contains(event.target)) dialog.focus({ preventScroll: true });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
